'use client';

import { StepperLeftPanel } from '@/src/components/steppers/StepperLeftPanel/StepperLeftPanel';
import { StepperStandard } from '@/src/components/steppers/StepperStandard/StepperStandard';
import { StepperScrollable } from '@/src/components/steppers/StepperScrollable/StepperScrollable';
import { IResolvedSteppers } from '@/src/utils/collections/steppers.mapper';

export const Stepper = (data: IResolvedSteppers) => {
  if (data.layout.type === 'leftPanel') {
    return <StepperLeftPanel {...data} />;
  } else if (data.layout.type === 'standard') {
    return <StepperStandard {...data} />;
  } else if (data.layout.type === 'scrollable') {
    return <StepperScrollable {...data} />;
  }
};
